import { useEffect, useState } from 'react';

// Reactive viewport breakpoint. The app is built with inline styles (no CSS
// framework), so components read this hook and swap the few layout-defining
// style props (gridTemplateColumns / flexDirection / width) for phones.
// 768px = the tablet/phone threshold; pass a custom width for finer control.
export function useIsMobile(maxWidth = 768): boolean {
  const query = `(max-width: ${maxWidth}px)`;
  const [matches, setMatches] = useState<boolean>(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}
